import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4cfb9309")

_pushScopeId("data-v-4cfb9309")
const _hoisted_1 = { class: "m-form-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      size: "medium",
      type: "primary",
      onClick: $setup.save,
      loading: $props.loading
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString($props.text), 1)
      ]),
      _: 1
    }, 8, ["onClick", "loading"])
  ]))
})